import { getUserAttribute, UserAttributes } from "../services/authorization";
import { IDP_PROFILE_CHECKER } from "../services/authorization/constants";

export default function checkIsProfileChecker() {
  return (
    getUserAttribute(UserAttributes.IdentityProvider) === IDP_PROFILE_CHECKER
  );
}
